// Collapses accidental duplicate slashes in a URL path
// (e.g. ".../api/player/l//api/player/l//x.jpg" -> ".../api/player/l/api/player/l/x.jpg")
// while preserving the protocol separator such as "http://" or "https://".
// Returns the value unchanged when it is empty/falsy.
const cleanImageUrl = (url) => (url ? String(url).replace(/([^:]\/)\/+/g, '$1') : url);

export default cleanImageUrl;
